export const settingsPath = () => '/settings' as const;
